import React, { useEffect, useState } from 'react';
// import PartnerShopDetailPage from '../partnerShop/PartnerShopDetailPage';
import Detail from './components/Detail';

const ADMIN_ORIGIN = 'http://localhost:43302';

export default function PartnerShopPreviewPage() {
  const [previewData, setPreviewData] = useState<any>(null);
  
  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (event.origin !== ADMIN_ORIGIN) return;

      if (event.data?.type !== 'PARTNER_SHOP_PREVIEW_UPDATE') return;

      setPreviewData(event.data.payload);
    }

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  if (!previewData) {
    return (
      <div style={{ padding: 40 }}>
        프리뷰 데이터를 기다리는 중입니다.
      </div>
    );
  }

  return <Detail {...previewData} />;
}